var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show(),
          expression: "show()",
        },
      ],
      key: _vm.messageId + "-" + _vm.tick,
      staticClass: "idle-indicator w-100",
    },
    [
      _c("a-divider", { staticClass: "idle" }, [_vm._v(_vm._s(_vm.time()))]),
      _vm._v(" "),
      _vm.tookTimeInSeconds() < 60
        ? _c("span", { staticClass: "idle-desc" }, [
            _vm._v(_vm._s(_vm.$t("auto.chatIdleDueToOneMinute"))),
          ])
        : _c("span", { staticClass: "idle-desc" }, [
            _vm._v(
              _vm._s(
                _vm.$t("chart.chatIdleDueToMinutes", {
                  n: _vm.tookTimeInMinutes(),
                })
              )
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }